const messages = {
  en: {
    ["footer-message"]: "For assistance with integration setup, please call",
  },
  fr: {
    ["footer-message"]: "Pour obtenir de l'aide concernant la configuration de l'intégration, veuillez appeler",
  },
};

export default messages;
